import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  first,
  withLatestFrom,
  switchMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as IncidentActions from './incident.actions';
import { IncidentService } from '../services/incident.service';
import { IncidentFacade } from './incident.facade';
import { IncidentStoreReducer, IncidentStoreSelectors } from '.';
import { Store } from '@ngrx/store';

@Injectable()
export class IncidentEffects {
  loadIncident$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IncidentActions.loadIncident),
      exhaustMap((_) =>
        this.incidentService.getIncident().pipe(
          map((data) =>
          IncidentActions.loadIncidentSuccess({
              incident: data,
            })
          ),
          catchError((error) =>
            of(
                IncidentActions.loadIncidentFailure({
                error,
              })
            )
          )
        )
      )
    )
  );

  clearIncident$ = createEffect(() =>
this.actions$.pipe(
  ofType(IncidentActions.clearIncident),
  exhaustMap((_) => of(IncidentActions.clearIncidentSuccess({
          Incident: [],
        }))))
);



  addIncident$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IncidentActions.addIncident),
      withLatestFrom(this.incidentFacade.loadRegister$),
      concatMap(
        ([{ newIncident}, getAllRegister]) =>
          this.incidentService
            .createIncident(newIncident)
            .pipe(
              map((data) => {
                this.notification.success('Saved Successfully');
                console.log('effect incident ', data, newIncident);
                // this.registerFacade.findIncidentRecord(data.id);


                return IncidentActions.addIncidentSuccess(
                  {
                    newIncident: data,
                  }
                );
              }),

              catchError((error) =>
                of(
                  IncidentActions.addIncidentFailure(
                    { error: error.error.message }
                  )
                )
              )
            )
      )
    )
  );

  updateIncident$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IncidentActions.updateIncident),
      map((action) => action.updateIncident),
      concatMap((updateIncident) =>
        this.incidentService
          .updateIncident(updateIncident)
          .pipe(
            map((mapIncident) => {
              this.notification.success('Updated Successfully');
              return IncidentActions.updateIncidentSuccess(
                {
                  updateIncident: mapIncident,
                }
              );
            }),
            catchError((error) =>
              of(
                IncidentActions.updateIncidentFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );



  fetchIncidentRecord$ = createEffect(() =>
  this.actions$.pipe(
    ofType(IncidentActions.fetchIncidentRecord),
    switchMap(({ fetch }) =>
      of(fetch).pipe(
        withLatestFrom(
          this.store.select(IncidentStoreSelectors.getAllIncident),
        ),
      )
    ),
    switchMap(([result, res]) => {

      return this.incidentService.fetchIncident(result).pipe(
        map((data) =>
          {
// console.log("result ", res);
           return IncidentActions.fetchIncidentRecordSuccess({ record: data })
          }
        ),
        catchError((error) => {
          this.notification.error(error.error.message);
          return of(
            IncidentActions.fetchIncidentRecordFailure({ error }),
          );
        }),
      );
    }),
  )
);



fetchByIdIncidentRecord$ = createEffect(() =>
this.actions$.pipe(
  ofType(IncidentActions.fetchByIdIncidentRecord),
  switchMap(({ id }) =>
    of(id).pipe(
      withLatestFrom(
        this.store.select(IncidentStoreSelectors.getAllIncident),
      ),
    )
  ),
  switchMap(([result, res]) => {
    // console.log("result ", res);
    return this.incidentService.fetchByIdIncident(result).pipe(
      map((data) =>
      IncidentActions.fetchByIdIncidentRecordSuccess({ record: data })
      ),
      catchError((error) => {
        this.notification.error(error.error.message);
        return of(
          IncidentActions.fetchByIdIncidentRecordFailure({ error }),
        );
      }),
    );
  }),
)
);



  removeIncident$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IncidentActions.removeIncident),
      map((action) => action.id),
      concatMap((id) =>
        this.incidentService
          .deleteIncident(id)
          .pipe(
            map(() => {
              this.notification.success('Deleted Successfully');
              return IncidentActions.removeIncidentSuccess(
                { id }
              );
            }),
            catchError((error) =>
              of(
                IncidentActions.updateIncidentFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private incidentService: IncidentService,
    private notification: NotificationService,
    private incidentFacade: IncidentFacade,
    private store: Store<IncidentStoreReducer.IncidentPartialState>,

  ) {}
}
